import { FC, HTMLAttributes } from 'react';
import { useProductContext } from 'mod/product-list/useProductContext';
import { EnergyLabel } from '@pro/common/EnergyLabel';

export type IProductEnergyLabelProps = HTMLAttributes<HTMLDivElement>;

export const ProductEnergyLabel: FC<IProductEnergyLabelProps> = props => {
    const {
        product
    } = useProductContext();

    // 如果产品没有能源标签数据则不渲染
    if (!product.energyLabel) {
        return null;
    }

    const { className, ...rest } = props;
    const { level, pic, pdf } = product.energyLabel;

    return (
        <EnergyLabel
            className={className}
            level={level}
            pic={pic}
            pdf={pdf}
            {...rest}
        />
    );
};
